/**
 * Created by Administrador on 11/22/2016.
 */
(function(){
    'use strict';

    var tabs = {
        transclude: true,
        templateUrl: 'app/components/tab/tabs.html',
        controller: tabsController,
        controllerAs: 'vm',
        bindings:{
            position: '@'
        }
    };

    angular
        .module('completeAir')
        .component('tabs', tabs);

    function tabsController(){
        var vm = this;

        vm.$onInit = function(){
            vm.tabs = [];

            if(vm.position == undefined || vm.position == ""){
                vm.position = "horizontal";
            }
        }

        vm.addTab = function(tab){
            vm.tabs.push(tab);
            if (vm.tabs.length > 0) {
                vm.tabs[0].selected = true;
            }
        }

        vm.selectTab = function(index){
            for (var i = 0; i < vm.tabs.length; i++) {
                vm.tabs[i].selected = false;
            }

            vm.tabs[index].selected = true;
        }

        vm.removeTab = function(index){
            vm.tabs.splice(index,1);
            if(vm.tabs.length > 0){
                vm.selectTab(0);
            }
        }
    }
})();
